import React, { useState } from 'react';
import RichText from '@grnhse/seedling/lib/azalea/components/forms/rich_text';

import { standardRequest } from 'shared/utils/request';
import Tribute from 'tributejs';
import { createGlobalStyle } from 'styled-components';
import { colors, fontWeight } from '@grnhse/seedling/lib/azalea/constants';
import _ from 'underscore';
import $ from 'legacy/jquery';
// @ts-expect-error - TS7016 - Could not find a declaration file for module 'trix'. 'node_modules/trix/dist/trix.js' implicitly has an 'any' type.
import Trix from 'trix';

type RawUser = {
  name: string;
  id: number;
};

type User = {
  key: string;
  value: string;
};

type Props = {
  hiddenFieldName: string;
  taggedFieldName: string;
  value: string;
  required?: boolean;
  additionalFields?: Array<{
    name: string;
    value: string;
    isRequired?: boolean;
  }>;
  getTagsUrl?: string;
  placeholder?: string;
  onSetNote?: (note: string) => void;
  onSetNoteWithTags?: (note: string) => void;
  className?: string;
};

type HiddenField = {
  name: string;
  value?: string;
  isRequired?: boolean;
};

const RichTextWithMentions = (props: Props) => {
  const [body, setBody] = useState(props.value || '');
  const [bodyWithTags, setBodyWithTags] = useState(props.value || '');

  // @ts-expect-error - TS7034 - Variable 'trixEditor' implicitly has type 'any' in some locations where its type cannot be determined.
  let trixEditor;
  const mentionsMinLength = 1;
  const tributeConfig = {
    values: [],
    trigger: '@',
    allowSpaces: true,
    spaceSelectsMatch: false,
    itemClass: 'suggestion pii-blur',
    menuShowMinLength: mentionsMinLength,
    selectTemplate: selectTemplate,
  } as const;

  function onEditorReady(editor: any): void {
    trixEditor = editor;
    registerMentions(editor);
  }

  function registerMentions(editor: any): void {
    // @ts-expect-error - TS2345 - Argument of type '{ readonly values: readonly []; readonly trigger: "@"; readonly allowSpaces: true; readonly spaceSelectsMatch: false; readonly itemClass: "suggestion"; readonly menuShowMinLength: 1; readonly selectTemplate: (item: any) => null; }' is not assignable to parameter of type 'TributeOptions<never>'.
    const tribute = new Tribute(tributeConfig);
    tribute.attach(editor.element);

    // @ts-expect-error - TS7006 - Parameter 'event' implicitly has an 'any' type.
    editor.element.addEventListener('tribute-active-true', (event) => {
      event.target.setAttribute(
        'data-last-position',
        editor.getSelectedRange()[0] - mentionsMinLength
      );
    });

    getUserOptions().then(({ data }) =>
      // @ts-expect-error - TS2345 - Argument of type 'User[]' is not assignable to parameter of type 'never[]'.
      tribute.append(0, normalizeUsers(data))
    );

    parseMentions();
  }

  function parseMentions(): undefined | null | undefined {
    if (!props.value) {
      return null;
    }

    const mentionsRegex = /@\[\[(.*?)\]\]/g; // matches @[[4041692002:User:@Dunk Arugula]]
    const mentionGroups = props.value.match(mentionsRegex);

    if (mentionGroups && mentionGroups.length) {
      mentionGroups.forEach((group) => {
        const userName = getUserNameFromToken(group);
        const mention = createMention(userName, group);

        substituteAttachment(group, mention);
      });
    }
  }

  function substituteAttachment(token: string, mention: any): void {
    // @ts-expect-error - TS7005 - Variable 'trixEditor' implicitly has an 'any' type.
    const initialValue = trixEditor.getDocument().toString();
    const selectStart = initialValue.indexOf(token);
    const selectEnd = selectStart + token.length;

    // @ts-expect-error - TS7005 - Variable 'trixEditor' implicitly has an 'any' type.
    trixEditor.setSelectedRange([selectStart, selectEnd]);
    // @ts-expect-error - TS7005 - Variable 'trixEditor' implicitly has an 'any' type.
    trixEditor.deleteInDirection('forward');
    // @ts-expect-error - TS7005 - Variable 'trixEditor' implicitly has an 'any' type.
    trixEditor.insertAttachment(mention);
  }

  // Parses Dunk Arugula from @[[4041692002:User:@Dunk Arugula]]
  function getUserNameFromToken(token: string) {
    return token.substring(3, token.length - 2).split(':@')[1];
  }

  function getUserOptions(): Promise<any> {
    return standardRequest.get(props.getTagsUrl);
  }

  function normalizeUsers(users: Array<RawUser>): Array<User> {
    return _.map(users, (user) => ({
      key: user.name.substring(1), // remove '@'
      value: `@[[${user.id}:User:${user.name}]]`,
    }));
  }

  function backspaceMentionsQuery(): void {
    const lastPosition =
      // @ts-expect-error - TS7005 - Variable 'trixEditor' implicitly has an 'any' type.
      trixEditor.element.getAttribute('data-last-position') - 1;
    // @ts-expect-error - TS7005 - Variable 'trixEditor' implicitly has an 'any' type.
    const currentPosition = trixEditor.getSelectedRange()[0];

    // @ts-expect-error - TS7005 - Variable 'trixEditor' implicitly has an 'any' type.
    trixEditor.setSelectedRange([lastPosition, currentPosition]);
    // @ts-expect-error - TS7005 - Variable 'trixEditor' implicitly has an 'any' type.
    trixEditor.deleteInDirection('forward');
  }

  function selectTemplate(item: any): null {
    const mention = createMention(item.original.key, item.original.value);

    backspaceMentionsQuery();
    // @ts-expect-error - TS7005 - Variable 'trixEditor' implicitly has an 'any' type.
    trixEditor.insertAttachment(mention);

    return null;
  }

  function createMention(text: string, value: string): any {
    // Trix sanitizes all class attributes except inside attachments, so
    // here we're adding mentions inside of one
    const embed = `<span class="trix-mention">@${text}</span>`;
    return new Trix.Attachment({
      content: embed,
      'attachment-type': 'trix-mention',
      'mention-value': value,
    });
  }

  function onEditorChange(html: any, text: any): void {
    const normalizedHtml = $(`<div>${html}</div>`);
    const trixAttachmentsTokens = normalizedHtml.find('[data-trix-attachment]');

    // @ts-expect-error - TS7006 - Parameter 'index' implicitly has an 'any' type. | TS7006 - Parameter 'attachment' implicitly has an 'any' type.
    trixAttachmentsTokens.each((index, attachment) => {
      const $attachment = $(attachment);
      const mentionValue = $attachment.data('trix-attachment')['mention-value'];
      const attachmentId = $attachment.data('trix-id');

      const $attachmentNode = normalizedHtml.find(
        `[data-trix-id="${attachmentId}"]`
      );
      $attachmentNode.prev().remove(); // remove cursor marker <span>'s
      $attachmentNode.next().remove();
      $attachmentNode.replaceWith(mentionValue);
    });

    setBody(text);
    setBodyWithTags(normalizedHtml.html());

    if (props?.onSetNote) {
      props.onSetNote(text);
    }

    if (props?.onSetNoteWithTags) {
      props.onSetNoteWithTags(normalizedHtml.html());
    }
  }

  function getInitialValue() {
    if (!props.value) {
      return null;
    }

    return props.value.replace(/\n/g, '<br />');
  }

  function hiddenFields(): Array<HiddenField> {
    if (props.taggedFieldName) {
      return [
        { name: props.hiddenFieldName, value: body },
        {
          name: props.taggedFieldName,
          value: bodyWithTags,
          isRequired: props.required,
        },
      ];
    }

    return [
      {
        name: `scorecard[${props.hiddenFieldName}]`,
        value: body,
      },
      {
        name: `scorecard[${props.hiddenFieldName}_with_tags]`,
        value: bodyWithTags,
      },
    ];
  }

  // @ts-expect-error - TS7031 - Binding element 'name' implicitly has an 'any' type. | TS7031 - Binding element 'value' implicitly has an 'any' type. | TS7031 - Binding element 'isRequired' implicitly has an 'any' type.
  function renderField({ name, value, isRequired }) {
    return (
      <input
        type="hidden"
        name={name}
        value={value}
        className="scorecard-react-input"
        data-required={isRequired}
      />
    );
  }

  return (
    <>
      <GlobalStyle />
      <div>
        {/* @ts-expect-error - TS2345 - Argument of type '({ name, value, isRequired }: { name: any; value: any; isRequired: any; }) => Element' is not assignable to parameter of type '(value: HiddenField, index: number, array: HiddenField[]) => Element'. */}
        {hiddenFields().map(renderField)}
        {/* @ts-expect-error - TS2345 - Argument of type '({ name, value, isRequired }: { name: any; value: any; isRequired: any; }) => Element' is not assignable to parameter of type '(value: { name: string; value: string; isRequired?: boolean | undefined; }, index: number, array: { name: string; value: string; isRequired?: boolean | undefined; }[]) => Element'. */}
        {props.additionalFields && props.additionalFields.map(renderField)}
        <RichText
          // @ts-expect-error - TS2322 - Type '{ value: string | null; hideAttachments: true; onEditorReady: (editor: any) => void; onChange: (html: any, text: any) => void; placeholder: string | undefined; }' is not assignable to type 'IntrinsicAttributes & Pick<Props, never> & InexactPartial<Pick<Props, "hideAttachments">> & InexactPartial<Pick<{ hideAttachments: boolean; }, never>>'.
          value={getInitialValue()}
          hideAttachments
          onEditorReady={onEditorReady}
          onChange={onEditorChange}
          placeholder={props.placeholder}
          className={props.className}
        />
      </div>
    </>
  );
};

const GlobalStyle = createGlobalStyle`
  span.trix-mention + figcaption {
    display: none;
  }
  .trix-mention {
    text-underline: none;
    display: inline-block;
    background: ${colors.lighterGreenhouseGreen};
    color: ${colors.darkestGrey};
    ${fontWeight('normal')};
  }

  // Tribute
  .tribute-container {
    z-index: 2000;
    max-height: 300px;
    min-width: 280px;
    border: 1px solid ${colors.lightGrey};
    background: ${colors.white};
    font-size: 14px;
    overflow: hidden;
  }
  .tribute-container .suggestion {
    ${fontWeight('normal')};
    padding: 4px 15px;

    &.highlight {
      background: ${colors.lighterGreenhouseGreen};
    }
  }
`;

export default RichTextWithMentions;
export { Props as RichTextWithMentionsProps };
